import {Component, Prop, Vue} from 'vue-property-decorator'
import PazTooltipButton from "@pazion/pazion-core/src/components/controls/PazTooltipButton.vue";
import {IDossier} from '@pazion/pazion-core/src/models/dossier.model';

@Component({
    components: {
        PazTooltipButton
    }
})
export default class DossierListMixin extends Vue {
    /**
     * Props
     */
    @Prop() dossierAccount!: IDossier[];
    @Prop({default: false}) public loading!: boolean;

    /**
     * Data
     */
    public expanded: [] = [];
    public search: string = "";
    public selectedGroupItem: IDossier | null = null;


    // Course data-table
    public dossierListPageHeaders: object = {
        main: [
            {
                text: "Name",
                align: "left",
                class: "cell-truncate nowrap",
                sortable: true,
                cellClass: "col-7",
                value: "name",
            }
        ],
    };
    public footer: object = {
        "items-per-page-options": [50, 100, 200],
    };

    /**
     * Methods
     */
    row_classes() {
        return "v-row-group__subrow";
    }

    openItem(item: IDossier) {
        const listElem = this.$refs[`list-${item.id}`];
        if (listElem) listElem[0].showItemFiles();
    }


    showDossierDetails(item: IDossier) {
        this.$router.push({path: `dossier/${item.id}`})
    }

    editDossier(item: IDossier, isTop?: boolean) {
        this.$emit('onDossierEdit', {item, isTop});
    }

    deleteDossier(item: IDossier) {
        this.$emit('onDossierDelete', item);
    }

    getStatusString(status: boolean) {
        return status ? 'active' : 'inactive';
    }

    onSelectListGroup(item: IDossier) {
        this.openItem(item);
        if (item.id === (this.selectedGroupItem && this.selectedGroupItem.id)) {
            this.selectedGroupItem = null;
            return
        }
        this.selectedGroupItem = item;
    }

    /**
     * Getters
     */
    get dossierListHeaders() {
        return this.isUserAdmin ? this.dossierListPageHeaders.main : this.dossierListPageHeaders.main.filter(h => h && h.value !== 'isAutoreset');
    }

    get dossierListBody() {
        return this.dossierAccount;
    }

    get getFilterDossiers(): IDossier[] {
        return this.dossierAccount;
        //negative if a is less than b, positive if a is greater than b,
    }

}//
